import { Autocomplete, Box, Button, Card, FormControl, Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, set, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { PermissionGuard } from '../../../../components/PermissionGuard';
import UnauthorizedPage from '../../../UnAuthorized';
import { UrbanTypeDataContext } from './UrbanType';
import { UrbanTypeServices } from './UrbanTypeServices';
import { normalizeNumericInput } from '../../../../utils/formatNumber';

const cities = [
    { cityId: 1, cityName: 'Noida', pinCodes: ['201301', '201302'] },
    { cityId: 2, cityName: 'Ghaziabad', pinCodes: ['110001', '110002'] },
    { cityId: 3, cityName: 'Gurugram', pinCodes: ['400001', '400002'] },
    // { cityId: 4, cityName: 'Bangalore', pinCodes: ['560001', '560002'] },
    // { cityId: 5, cityName: 'Chennai', pinCodes: ['600001', '600002'] },
];

const AddEditForm = () => {
    const {urbanTypeInitialData,urbanTypeData,setUrbanTypeData,fetchUrbanTypeList,urbanTypeList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedUrbanTypeData, setSelectedUrbanTypeData} = useContext(UrbanTypeDataContext)
    const [pageTitle, setPageTitle] = useState('Add Subscription Type');
    const {control,handleSubmit,formState:{errors,isDirty},reset,watch,setValue,clearErrors} = useForm({
        mode:'onChange',
        defaultValues:urbanTypeData,
    });
    const [isSubmitted,setIsSubmitted] = useState(false);
    const onSubmit = async (data)=>{
        setIsSubmitted(true);
        console.log("data:",data);
        const ModifiedData = {
            typeTitle: data.typeTitle,
            numberOfExpertOrderFree: data.numberOfExpertOrderFree,
            typeCities: data.typeCities||[],
            typeCitiesPinCodes: data.typeCitiesPinCodes || [],
            typeDescription: data.typeDescription,
            status:data.status,
        }
        try{
            if(selectedUrbanTypeData){
                //update
                const updateresponse = await UrbanTypeServices.updateUrbanType(ModifiedData,selectedUrbanTypeData.id);
                if(updateresponse.success == '1'){
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Data updated successfully',
                    })
                    fetchUrbanTypeList();
                    setSelectedUrbanTypeData(null);
                    setUrbanTypeData(urbanTypeInitialData);
                    reset(urbanTypeInitialData);
                }else if(updateresponse.success == '0'){                    
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: updateresponse.message || 'failed to update data',
                    })
                }
            }else{
                //save
                const saveresponse = await UrbanTypeServices.addUrbanType(ModifiedData);
                if(saveresponse.success == '1'){
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Data saved successfully',
                    })
                    fetchUrbanTypeList();
                    reset(urbanTypeInitialData);
                }else if(saveresponse.success == '0'){
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: saveresponse.message || 'failed to save data',
                    })
                }
            }
        }catch (error){
            console.log("error:",error)
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'failed to save data...Something went wrong!',
            })
        }finally{
            setIsSubmitted(false);
        }
    }
    useEffect(()=>{
        if(selectedUrbanTypeData){
            setPageTitle('Edit Subscription Type');
            const modifiedData = {
                ...selectedUrbanTypeData,
                typeCities:selectedUrbanTypeData.typeCities?selectedUrbanTypeData.typeCities:[],
                typeCitiesPinCodes:selectedUrbanTypeData.typeCitiesPinCodes?selectedUrbanTypeData.typeCitiesPinCodes:[],
            }
            setUrbanTypeData(modifiedData);
            reset(modifiedData,{isDirty:false});
            console.log("selected urban Data:",selectedUrbanTypeData)
        }
    },[selectedUrbanTypeData])

    
    const Submitting = ()=>{
        Swal.fire({
            title: 'Please wait...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
    }
    const resetFormField = ()=>{
        reset(urbanTypeInitialData);
        setSelectedUrbanTypeData(null);
        setUrbanTypeData(urbanTypeInitialData);
        setPageTitle('Add Urban Type');
    }
    const [pincodes, setPincodes] = useState([]);
    useEffect(() => {
        console.log("watch typeCities changed:", watch('typeCities'));
        if (watch('typeCities').length>0) {
            setPincodes([]);
            // const allPincodes = watch('typeCities').flatMap(city => city.pinCodes);
            const allPincodes = [];
            watch('typeCities').forEach(cityName => {
                const city = cities.find(c => c.cityName === cityName);
                if (city) {
                    allPincodes.push(...city.pinCodes);
                }
            });
            setPincodes(allPincodes);
            // if selected pincodes are not in the new list, remove them
            const selectedPincodes = watch('typeCitiesPinCodes') || [];
            const filteredSelectedPincodes = selectedPincodes.filter(pin => allPincodes.includes(pin));
            setValue('typeCitiesPinCodes', filteredSelectedPincodes);
        }else{
            setPincodes([]);
        }
    }, [watch('typeCities')]);
  return (
    <PermissionGuard feature="gst" permission={selectedUrbanTypeData ?'canEdit':"canCreate"} fallback={selectedUrbanTypeData && <UnauthorizedPage/>}>
        <Card>
            {isSubmitted && Submitting()}
            <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
                <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >{pageTitle}</Typography>
            </Box>
            <Box component={'form'} onSubmit={handleSubmit(onSubmit)} sx={{p:1}}>
                
                <Grid container spacing={2}>
                    <Grid item xs={7}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Expert Free Order Count <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            name="numberOfExpertOrderFree"
                            control={control}
                            rules={{
                            required: 'Value is required',
                            validate: (value) => {
                                const intValue = parseInt(value, 10);
                                return !isNaN(intValue) && intValue >= 0 || 'Value should be a non-negative integer';
                            }
                            }}
                            defaultValue={0}
                            render={({ field, fieldState: { error } }) => (
                            <TextField
                                {...field}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    let finalValue;
                                    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                                    finalValue = normalizeNumericInput(inputValue);
                                    console.log("finalValue",finalValue)

                                    if(finalValue==''){
                                        finalValue=0
                                    }

                                    field.onChange(finalValue);
                                    }
                                }}
                                fullWidth
                                type="number"
                                inputMode="numeric"
                                size="small"
                                inputProps={{
                                    style: { textAlign: 'center', height: '1rem',fontSize:'0.65rem'},
                                    min: 0,
                                    step: 1, // Only allow whole numbers
                                    onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                        onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                    onKeyDown: (e) => {
                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                error={!!error}
                            />
                            )}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600 }}>Status <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box> : </Typography>
                        <Controller
                            name='status'
                            control={control}
                            rules={{
                                validate: value => {
                                    return true;
                                }
                            }}
                            render={({field,fieldState:{error}})=>
                                <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                    <Select
                                        {...field}
                                        error={!!error}
                                        sx={{
                                            fontSize:'0.65rem',
                                        }}
                                    >                                    
                                        <MenuItem value={true} sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>True</MenuItem>
                                        <MenuItem value={false} sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>False</MenuItem>                                   
                                    </Select>
                                </FormControl>
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Title <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            name='typeTitle'
                            control={control}
                            rules={{
                                required:'title required',
                            }}
                            render={({field,fieldState:{error}})=>
                                <TextField
                                    {...field}
                                    size='small'
                                    fullWidth
                                    // type='number'
                                    error={!!error}
                                    inputProps={{
                                        style:{
                                            fontSize:'0.65rem'
                                        },
                                    }}
                                />
                            }
                        />
                    </Grid>
                    
                     <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Description</Typography>
                        <Controller
                            name='typeDescription'
                            control={control}
                            rules={{
                                // required:'description required',
                            }}
                            render={({field,fieldState:{error}})=>
                                <TextField
                                    {...field}
                                    size='small'
                                    multiline
                                    rows={3}
                                    fullWidth
                                    // type='number'
                                    error={!!error}
                                    inputProps={{
                                        style:{
                                            fontSize:'0.65rem'
                                        },
                                    }}
                                />
                            }
                        />
                    </Grid>
                    {/* autocomplete multiple city select */}
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>City</Typography>
                        <Controller
                            control={control}
                            name="typeCities"
                            rules={{
                                // required: 'Select at least one city',
                            }}
                            render={({ field, fieldState: { error } }) => (
                            <Autocomplete
                                fullWidth
                                options={cities}
                                multiple
                                size='small'
                                getOptionLabel={(option) => option?.cityName || ''}
                                isOptionEqualToValue={(option, value) =>
                                    option.cityId === (value?.cityId || value)
                                }
                                value={
                                    Array.isArray(field.value)
                                    ? cities.filter((city) => field.value.includes(city.cityName))
                                    : []
                                }
                                // onChange={(event, newValue) => {
                                //     // let finalValue = {
                                //     //     cityId: newValue?.cityId || null,
                                //     //     title: newValue?.cityName || '',
                                //     // };
                                //     field.onChange(newValue);
                                // }}
                                onChange={(event, newValue) => {
                                    const selectedNames = newValue.map((item) => item.cityName);
                                    console.log("Selected city names:", selectedNames);
                                    field.onChange(selectedNames);
                                }}
                                disableClearable
                                // disabled={!watch('childService')}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        // label="Select SAC Code*"
                                        placeholder='Search and Select City'
                                        error={!!error}
                                        // helperText={error ? error.message : ''}
                                        size="small"
                                        inputProps={{
                                            ...params.inputProps,
                                            style: { fontSize: '0.75rem' }
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                        {option.cityName || ''}
                                    </MenuItem>
                                )}
                            />
                        )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Pincodes </Typography>
                        <Controller
                            control={control}
                            name="typeCitiesPinCodes"
                            // rules={{
                            //     required: 'Select at least one city',
                            // }}
                            render={({ field, fieldState: { error } }) => (
                            <Autocomplete
                                fullWidth
                                options={pincodes}
                                multiple
                                size='small'
                                getOptionLabel={(option) => option || ''}
                                isOptionEqualToValue={(option, value) =>
                                    option === (value || '')
                                }
                                value={field.value || null}
                                onChange={(event, newValue) => {
                                    // let finalValue = {
                                    //     cityId: newValue?.cityId || null,
                                    //     title: newValue?.cityName || '',
                                    // };
                                    field.onChange(newValue);
                                }}
                                disableClearable
                                // disabled={!watch('childService')}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        // label="Select SAC Code*"
                                        placeholder='Search and Select City'
                                        error={!!error}
                                        // helperText={error ? error.message : ''}
                                        size="small"
                                        inputProps={{
                                            ...params.inputProps,
                                            style: { fontSize: '0.75rem' }
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                        {option || ''}
                                    </MenuItem>
                                )}
                            />
                        )}
                        />
                    </Grid>
                    {/* <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Pincodes <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            control={control}
                            name="typeCitiesPinCodes"
                            rules={{
                                required: 'Select at least one pincode',
                            }}
                            render={({ field, fieldState: { error } }) => (
                                <Autocomplete
                                    {...field}
                                    multiple
                                    size='small'
                                    fullWidth
                                    options={watch('typeCities') ? watch('typeCities').flatMap(city => city.pinCodes) : []}
                                    getOptionLabel={(option) => option.pinCode}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            error={!!error}
                                            helperText={error ? error.message : null}
                                        />
                                    )}
                                />
                            )}
                        />
                    </Grid> */}
                    <Grid item xs={12} sx={{display:'flex',justifyContent:'center',gap:2}}>
                        <Button 
                            variant='contained' 
                            size='small' 
                            color='error'
                            onClick={resetFormField}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant='contained' 
                            size='small' 
                            type='submit'
                            disabled={!isDirty}
                        >
                            {selectedUrbanTypeData ? 'update':'Save'}
                        </Button>
                    </Grid>
                </Grid>
                
                
            </Box>
        </Card>
    </PermissionGuard>
  );
}

export default AddEditForm;
const formatValue = (value) => {
    if (typeof value !== 'string') {
      return value === 0 ? 0 : value?.toString() || '';
    }
    // const formatted = value.replace(/^0+(?=\d)/, '').replace(/^\./, '0.');
    // return formatted === '' ? '' : formatted
    // ;
    // Remove leading zeros except for "0." pattern
    const formatted = value.replace(/^0+(?=\d)/, '');
    
    // Handle decimal point at start
    return formatted.startsWith('.') ? `0${formatted}` : formatted;
};